// Auto-Complete on a Time & Materials task (jobq-api 1b floor rule): the API answers
// 400 {detail: {code: 'tm_actual_minutes_required', message, estimate_minutes}} until the operator
// types the real minutes (0.5 to 1440). They become the billed time, so the prompt starts BLANK
// (never the estimate). A fixed-price task never sees this; the API ignores actual_minutes there.

export const TM_MINUTES_MIN = 0.5;
export const TM_MINUTES_MAX = 1440;

export function isTmMinutesRequired(status, detail) {
  return status === 400 && !!detail && typeof detail === 'object' && detail.code === 'tm_actual_minutes_required';
}

/** A typed value as the minutes string to send, or null when it is not a number from 0.5 to 1440. */
export function typedMinutes(raw) {
  if (raw === null || raw === undefined) return null;
  const s = String(raw).trim();
  if (!/^\d+(\.\d+)?$|^\.\d+$/.test(s)) return null;
  const m = Number(s);
  if (!Number.isFinite(m) || m < TM_MINUTES_MIN || m > TM_MINUTES_MAX) return null;
  return s.startsWith('.') ? `0${s}` : s;
}

function minutesQuestion(detail) {
  const est = detail && detail.estimate_minutes != null ? ` (the estimate was ${detail.estimate_minutes} min)` : '';
  return {
    first: `${(detail && detail.message) || 'T&M job: enter the actual minutes spent.'}\n\nActual minutes${est}:`,
    again: (raw) => `"${String(raw).trim()}" isn't a number of minutes from ${TM_MINUTES_MIN} to ${TM_MINUTES_MAX}. Type the actual minutes spent${est}:`,
  };
}

/**
 * Ask for the actual minutes until they are valid. Cancel (null) stops: returns null.
 * promptFn defaults to window.prompt (the house pattern for a typed reason).
 */
export function askTypedMinutes(detail, promptFn = (msg, def) => window.prompt(msg, def)) {
  const q = minutesQuestion(detail);
  let msg = q.first;
  for (;;) {
    const raw = promptFn(msg, '');
    if (raw === null || raw === undefined) return null;
    const m = typedMinutes(raw);
    if (m !== null) return m;
    msg = q.again(raw);
  }
}

/** askTypedMinutes for a prompt that answers later (the phone's panel): same questions. */
export async function askTypedMinutesAsync(detail, promptFn) {
  const q = minutesQuestion(detail);
  let msg = q.first;
  for (;;) {
    const raw = await promptFn(msg, '');
    if (raw === null || raw === undefined) return null;
    const m = typedMinutes(raw);
    if (m !== null) return m;
    msg = q.again(raw);
  }
}
